import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';

export const formatDate = (date: number | Date, dateFormat: string) =>
  format(date, dateFormat, { locale: fr });
